import { postFeatureInteraction } from "../global/API";
import { FeatureState } from "../global/FeatureState";

export const FeatureLogs = async(aid, featureName, tid) => {
    // console.log('featureName', featureName)
    const today = new Date();
    let featureLogs = JSON.parse(localStorage.getItem("sip_feature_logs"));
    const sameUser = featureLogs && featureLogs[0].aid === aid;
    // console.log('sameUser', !sameUser)
    if (!sameUser) {
        featureLogs = []
        localStorage.removeItem("sip_feature_logs");
        // console.log('deleted featureLogs')
    }
    // console.log('featureLogs', featureLogs)
    const isSameDay = (d1, d2) => {
        return (
            d1.getFullYear() === d2.getFullYear() &&
            d1.getMonth() === d2.getMonth() &&
            d1.getDate() === d2.getDate()
        );
    }
    if (featureLogs) {
        const logIndex = featureLogs.findIndex(item => item.feature_name === featureName );
        if (logIndex > -1) {
            const date_logged = new Date(featureLogs[logIndex].date_logged)
            const isLogged = isSameDay(date_logged, today)
            if (isLogged) {
                // console.log(`${featureName} has already been accessed today`)
                return
            } else {
                featureLogs.splice(logIndex, 1);
                localStorage.setItem("sip_feature_logs", JSON.stringify(featureLogs));
                // console.log(`${featureName} was removed from local storage since its not up to date`)
            }
        } 
    }
    const ftrdata = FeatureState(featureName) || console.log('Feature name is not found')
    if (!ftrdata) return
    const body = {
        aid: aid,
        tid: tid,
        company_id: 0,
        feature_id: ftrdata?.id,
        feature_name: ftrdata?.feature_name.toLowerCase(),
        path: ftrdata?.path,
        action: ftrdata?.action
    }
    const allLogList = () => {
        if (featureLogs && featureLogs.length > 0) {
            return featureLogs
        } else {
            return []
        }
    }

    // console.log('calling feature api')
    // console.log('body', body)
    const res = await postFeatureInteraction(body)
    if (res.msg === 'success' || res.msg === 'exist') {
        localStorage.setItem('sip_feature_logs', 
            JSON.stringify([...allLogList(), {aid: aid, date_logged: today, feature_name: body.feature_name}]))
        // console.log(`response message: ${res.msg}, ${featureName} was added to local storage, see you tommorow`)
    }
}